import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { Card, Icon, Typography } from 'antd'
import styles from './index.module.less'

interface ParentOrganizationProps {
	link: string
	name: string
}

const ParentOrganization: FC<ParentOrganizationProps> = ({ link, name }) => (
	<Card type="inner" className={styles.card} title={<Typography.Text type='secondary'>Parent Organization</Typography.Text>}>
		<Link to={link}>
			<Icon type='link' className={styles.titleIcon} />
			{name}
		</Link>
	</Card>
)

export default ParentOrganization
